export default "__VITE_ASSET__76f38cc0__"